import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

let activeGarageId = null;
export const setApiGarage = (id) => {
  activeGarageId = id || null;
};

api.interceptors.request.use((cfg) => {
  if (activeGarageId && !cfg.headers["X-Garage-Id"]) cfg.headers["X-Garage-Id"] = activeGarageId;
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    if (err.response?.status === 401 && !cfg._retry && !url.includes("/auth/login") && !url.includes("/auth/refresh")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch {
        /* fall through to original error */
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.response ? fallback : "We couldn't reach the server. Check your connection and try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg ? x.msg.replace(/^Value error, /, "") : JSON.stringify(x))).join(" ");
  if (d.message) return d.message;
  return fallback;
}

export const errDetail = (e) => {
  const d = e?.response?.data?.detail;
  return d && typeof d === "object" && !Array.isArray(d) ? d : null;
};

export const fileUrl = (p) => (p ? `${BACKEND}${p}` : null);

export async function downloadFile(path, params) {
  const res = await api.get(path, { params, responseType: "blob" });
  const cd = res.headers["content-disposition"] || "";
  const name = (cd.match(/filename="([^"]+)"/) || [])[1] || "export";
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
}
